module.exports = __webpack_public_path__ + "img/360-4.f7f38bd.jpg";